import flagZh from '@/assets/images/nationalFlag/中国@2x.png';
import flagEn from '@/assets/images/nationalFlag/英国@2x.png';
import flagDe from '@/assets/images/nationalFlag/德国@2x.png';
import flagHu from '@/assets/images/nationalFlag/匈牙利@2x.png';
import flagVi from '@/assets/images/nationalFlag/vn.png';
import flagPtBr from '@/assets/images/nationalFlag/ptBr.png';
import flagTh from '@/assets/images/nationalFlag/th.png';
import flagId from '@/assets/images/nationalFlag/id.png';
import flagRu from '@/assets/images/nationalFlag/ru.png';

/** 语言 → 本地国旗资源（NavBar / Footer 共用） */
export const NATION_LOGO_MAP: Record<string, string> = {
  zh: flagZh,
  zh_Hant: flagZh,
  en: flagEn,
  de: flagDe,
  hu: flagHu,
  vi: flagVi,
  'pt-BR': flagPtBr,
  th: flagTh,
  id: flagId,
  ru: flagRu,
};

export const getNationLogo = (lang?: string): string => {
  if (!lang) {
    return '';
  }
  return NATION_LOGO_MAP[lang] || '';
};
